<div class="thank-you-container">
  <img alt="thank you" src="/img/documents.png">

  <div class="text header">
    <span>{{ 'ThankYouWithoutDocuments.Title' | translate | translateCut:0 }} &nbsp;</span>
    <span class="red">
      {{ 'ThankYouWithoutDocuments.Title' | translate | translateCut:1 }}
    </span>
  </div>

  <img alt="documents info" src="/img/documents-info.png">

  <div [innerHTML]="'ThankYouWithoutDocuments.Info.Title' | translate" class="text mt-1">
  </div>

  <div [innerHTML]="'ThankYouWithoutDocuments.Info.SubTitle' | translate" class="text mt-2">
  </div>

  <div [innerHTML]="'ThankYouWithoutDocuments.SendVia.Title' | translate" class="text info mt-2">
  </div>

  <div class="buttons-container">
    <button (click)="openExternal('ThankYouWithoutDocuments.SendVia.EmailAction')">
      <svg fill="none" height="17" viewBox="0 0 18 17" width="18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.25 0H3.75C2.7558 0.00119089 1.80267 0.396662 1.09966 1.09967C0.396661 1.80267 0.00119089 2.7558 0 3.75L0 12.75C0.00119089 13.7442 0.396661 14.6973 1.09966 15.4003C1.80267 16.1033 2.7558 16.4988 3.75 16.5H14.25C15.2442 16.4988 16.1973 16.1033 16.9003 15.4003C17.6033 14.6973 17.9988 13.7442 18 12.75V3.75C17.9988 2.7558 17.6033 1.80267 16.9003 1.09967C16.1973 0.396662 15.2442 0.00119089 14.25 0ZM3.75 1.5H14.25C14.6991 1.50088 15.1376 1.63614 15.5092 1.88835C15.8808 2.14057 16.1684 2.49821 16.335 2.91525L10.5915 8.6595C10.1688 9.08049 9.59656 9.31685 9 9.31685C8.40344 9.31685 7.83118 9.08049 7.4085 8.6595L1.665 2.91525C1.83161 2.49821 2.11921 2.14057 2.49079 1.88835C2.86236 1.63614 3.30091 1.50088 3.75 1.5ZM14.25 15H3.75C3.15326 15 2.58097 14.7629 2.15901 14.341C1.73705 13.919 1.5 13.3467 1.5 12.75V4.875L6.348 9.72C7.05197 10.4222 8.00569 10.8165 9 10.8165C9.99431 10.8165 10.948 10.4222 11.652 9.72L16.5 4.875V12.75C16.5 13.3467 16.2629 13.919 15.841 14.341C15.419 14.7629 14.8467 15 14.25 15Z"
          fill="white"/>
      </svg>

      <span> {{ 'ThankYouWithoutDocuments.SendVia.Email' | translate }} </span>
    </button>

    <button (click)="openExternal('ThankYouWithoutDocuments.SendVia.WhatsAppAction')" class="empty">
      <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4030_8440)">
          <path
            d="M15.3774 2.61627C13.6852 0.930136 11.4351 0.00104275 9.03772 0C4.09791 0 0.0770126 4.00104 0.074917 8.91866C0.0743932 10.4906 0.487223 12.025 1.27149 13.3775L0 18L4.75121 16.7596C6.06042 17.4703 7.53414 17.8446 9.03405 17.8451H9.03772C13.977 17.8451 17.9979 13.8436 18 8.92596C18.001 6.54275 17.0696 4.30188 15.3774 2.61627ZM9.03772 16.3389H9.03458C7.69812 16.3389 6.38681 15.9807 5.24315 15.3055L4.97124 15.1449L2.15216 15.8811L2.90448 13.1455L2.7274 12.865C1.9819 11.6846 1.58793 10.3201 1.58845 8.91971C1.59002 4.83212 4.93195 1.50678 9.04086 1.50678C11.0306 1.5073 12.9009 2.27946 14.3071 3.68092C15.7137 5.08186 16.4875 6.94473 16.487 8.92544C16.4854 13.013 13.1435 16.3389 9.03772 16.3389Z"
            fill="#092473"/>
          <path
            d="M13.1239 10.7852V10.7867C12.9008 10.6752 11.7995 10.1361 11.5942 10.0615C11.3888 9.98695 11.2395 9.94993 11.0902 10.1731C10.9409 10.3962 10.5118 10.8983 10.3813 11.0469C10.2509 11.196 10.1199 11.2143 9.89622 11.1027C9.67251 10.9911 8.95058 10.7555 8.09559 9.99634C7.42972 9.40562 6.98021 8.67569 6.84976 8.45254C6.71931 8.22939 6.83562 8.10895 6.94826 7.9979C7.04884 7.89832 7.17196 7.73773 7.28407 7.60739C7.39619 7.47705 7.43338 7.38424 7.50778 7.23513C7.58217 7.08653 7.54497 6.95619 7.48892 6.84461C7.43286 6.73304 6.98493 5.63606 6.79842 5.18977C6.61663 4.75546 6.43222 4.81385 6.29443 4.80708C6.16398 4.8003 6.01467 4.79926 5.86536 4.79926C5.71605 4.79926 5.47349 4.85504 5.26812 5.07819C5.06276 5.30134 4.48438 5.84044 4.48438 6.93742C4.48438 8.0344 5.28698 9.09435 5.39857 9.24295C5.51069 9.39154 6.97759 11.6428 9.22406 12.6079C9.75843 12.8373 10.1755 12.9744 10.5008 13.0771C11.0373 13.2466 11.5255 13.2226 11.9111 13.1653C12.3412 13.1011 13.236 12.6262 13.4226 12.1053C13.6091 11.585 13.6091 11.1387 13.553 11.0453C13.4969 10.9525 13.3476 10.8968 13.1239 10.7852Z"
            fill="#092473"/>
        </g>
        <defs>
          <clipPath id="clip0_4030_8440">
            <rect fill="white" height="18" width="18"/>
          </clipPath>
        </defs>
      </svg>

      <span> {{ 'ThankYouWithoutDocuments.SendVia.WhatsApp' | translate }} </span>
    </button>
  </div>

  <button (click)="redirectService.redirectToIL()" class="back-to-home mt-3">
    {{ 'ThankYouWithoutDocuments.BackToHome' | translate }}
    <span class="symbol"> &larr; </span>
  </button>
</div>
